import { Row, Col, Label, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Btn, UL, LI } from 'AbstractElements';
import { XCircle, CheckSquare } from 'react-feather';
import RawHTMLComponent from 'Component/Learning/Common/RawHTML';
import formatNumberCompact from 'Utils/formatNumberCompact';
import { getInteractiveType, getNonInteractiveQuestionType } from 'Utils/getQuestionType';
// import ModalComponent from 'Component/Learning/Common/Modal/ModalGeneral';
// import AdminShapePreview from 'Component/Learning/BankQuestion/AdminShapePreview';
import {
  CLICKABLE_LENGTH_BY_TYPE,
  // getShapePreset,
  // getShapeVariant,
} from 'Component/Learning/BankQuestion/questionsForm.helpers';

const DetailModal = ({ item, modal, NewMessage, toggle }) => {
  // Parse scores dari pivot
  const scores = JSON.parse(item.pivot.score);

  // ✅ Normalize flags untuk interactive
  const isInteractiveEnabled =
    item?.is_interactive === 1 ||
    item?.is_interactive === '1' ||
    item?.is_interactive === true;
  const isClickableInteractive = isInteractiveEnabled && item?.interactive_type === 'clickable';
  const isDragpinInteractive = isInteractiveEnabled && item?.interactive_type === 'dragpin';

  // clickable_type bisa ada di root atau nested
  const clickableType = item?.clickable_type ?? item?.interactive_detail?.[0]?.clickable_type;
  const clickableTypeLabel = clickableType === 'triangle'
    ? 'Segitiga'
    : clickableType === 'box'
      ? 'Persegi'
      : clickableType === 'boxhard'
        ? 'Persegi Kompleks'
        : 'Other';

  // jumlah cell untuk clickable
  const clickableCellCount = clickableType ? CLICKABLE_LENGTH_BY_TYPE[clickableType] : undefined;

  // dragpin detail biasanya tersimpan di interactive_detail[0]
  // NOTE: fallback ke root untuk berjaga-jaga jika backend mengirim field di root.
  const dragpinRoomCount = item?.room_count ?? item?.interactive_detail?.[0]?.room_count;
  const dragpinPinCount = item?.pin_count ?? item?.interactive_detail?.[0]?.pin_count;

  // Parse answer untuk preview clickable
  // const safeJsonParseArray = (value) => {
  //   try {
  //     const parsed = JSON.parse(value);
  //     return Array.isArray(parsed) ? parsed : [];
  //   } catch {
  //     return [];
  //   }
  // };
  // const answerArray = item.answer && item.answer[0] && item.answer[0].answer
  //   ? safeJsonParseArray(item.answer[0].answer)
  //   : [];
  // const clickablePreset = isClickableInteractive ? getShapePreset(answerArray) : [];

  // Map choices dengan informasi benar/salah & poin
  const choicesWithLabel = item.choices.map(choice => {
    const matchingScore = scores.find(score => score.choice_id === choice.id.toString());
    const newChoice = { ...choice };

    if (matchingScore) {
      newChoice.isCorrect = true;
      newChoice.point = matchingScore.point;
    } else {
      newChoice.isCorrect = false;
    }

    return newChoice;
  });

  return (
    <Modal isOpen={modal} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>
        {NewMessage}
      </ModalHeader>
      <ModalBody>
        {/* Info dasar soal - mirip struktur QuestionDetail */}
        <div className="pro-group pt-0 border-0">
          <Row>
            <Col xs="auto">
              <div className="product-price">Label Soal: </div>
              <b>{item.title}</b>
            </Col>
            <Col xs="auto">
              <div className="product-price">Tipe Soal: </div>
              <b>{getNonInteractiveQuestionType(item)}</b>
            </Col>
            <Col xs="auto">
              <div className="product-price">Kategori Soal: </div>
              <b>{item.pivot.category.title.replace(/\d/g, '')}</b>
            </Col>
          </Row>

          {/* Baris kedua: info interaktif (kalau ada) */}
          {item.type === 'sentence_arrangement' && (
            <Row className="mt-2">
              <Col xs="auto">
                <div className="product-price">Apakah soal interaktif: </div>
                <b>{isInteractiveEnabled ? 'Yes' : 'No'}</b>
              </Col>
              {isInteractiveEnabled && (
                <>
                  <Col xs="auto">
                    <div className="product-price">Tipe Interaktif: </div>
                    <b>{getInteractiveType(item)}</b>
                  </Col>
                  {/* Tampilkan Step hanya untuk bar_chart / line_chart */}
                  {(item.interactive_type === "bar_chart" || item.interactive_type === "line_chart") && (
                    <Col xs="auto">
                      <div className="product-price">Step: </div>
                      <b>{formatNumberCompact(item?.interactive_detail?.[0]?.step || "1")}</b>
                    </Col>
                  )}
                </>
              )}
            </Row>
          )}

          {/* Info interaktif untuk fill_in_the_blanks (clickable) */}
          {item.type === 'fill_in_the_blanks' && isInteractiveEnabled && (
            <Row className="mt-2">
              <Col xs="auto">
                <div className="product-price">Apakah soal interaktif: </div>
                <b>Yes</b>
              </Col>
              <Col xs="auto">
                <div className="product-price">Tipe Interaktif: </div>
                <b>{getInteractiveType(item)}</b>
              </Col>
              {isClickableInteractive && (
                <>
                  <Col xs="auto">
                    <div className="product-price">Tipe Clickable: </div>
                    <b>{clickableTypeLabel}</b>
                  </Col>
                  <Col xs="auto">
                    <div className="product-price">Jumlah Cell: </div>
                    <b>{clickableCellCount ? formatNumberCompact(clickableCellCount) : 'Tidak ada'}</b>
                  </Col>
                  {/* {clickableType && (
                    <Col xs="auto">
                      <ModalComponent
                        title={`Preview Pola Bentuk (${clickableTypeLabel})`}
                        type="component"
                        content={
                          <AdminShapePreview
                            variant={getShapeVariant(clickableType)}
                            preset={clickablePreset}
                            readOnly={true}
                            height={420}
                          />
                        }
                        buttonLabel={<i className="fa fa-eye fa-lg"></i>}
                        buttonSize="sm"
                        size="lg"
                        messageTooltip="Preview pola clickable"
                      />
                    </Col>
                  )} */}
                </>
              )}
              {isDragpinInteractive && (
                <>
                  <Col xs="auto">
                    <div className="product-price">Jumlah Room: </div>
                    <b>{dragpinRoomCount ? formatNumberCompact(dragpinRoomCount) : 'Tidak ada'}</b>
                  </Col>
                  <Col xs="auto">
                    <div className="product-price">Jumlah Pin: </div>
                    <b>{dragpinPinCount ? formatNumberCompact(dragpinPinCount) : 'Tidak ada'}</b>
                  </Col>
                </>
              )}
            </Row>
          )}
        </div>

        {/* Pertanyaan */}
        <div className="pro-group mb-3 mt-3">
          <div className="product-price mb-2">Pertanyaan: </div>
          <RawHTMLComponent htmlContent={item.description} />
        </div>

        {/* Pilihan Jawaban (hanya untuk multiple_choice / sentence_arrangement) */}
        {(item.type === 'multiple_choice' || item.type === 'sentence_arrangement') && (
          <div className="pro-group">
            <div className="product-price mb-3">Pilihan Jawaban:</div>
            <UL attrUL={{ className: 'simple-list' }}>
              {choicesWithLabel && choicesWithLabel.map((itemChoice, index) => (
                <LI key={itemChoice.id} className="mt-3">
                  <Row>
                    <Col>
                      <Label className="form-check-label" htmlFor={`itemChoice-${index}`}>
                        <RawHTMLComponent htmlContent={itemChoice.choice} />
                      </Label>
                    </Col>
                    {/* Info benar/salah hanya untuk multiple_choice */}
                    {item.type === 'multiple_choice' && (
                      <Col xs="auto">
                        {itemChoice.isCorrect ? (
                          <>
                            <CheckSquare color="green" style={{ verticalAlign: 'middle' }} />
                            <span style={{ verticalAlign: 'middle' }}>
                              {' '}Benar <b>({itemChoice.point} poin)</b>
                            </span>
                          </>
                        ) : (
                          <>
                            <XCircle color="red" style={{ verticalAlign: 'middle' }} />
                            <span style={{ verticalAlign: 'middle' }}>{' '}Salah</span>
                          </>
                        )}
                      </Col>
                    )}
                  </Row>
                </LI>
              ))}
            </UL>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Btn attrBtn={{ color: 'warning', onClick: toggle }}>Close</Btn>
      </ModalFooter>
    </Modal>
  );
};

export default DetailModal;